const MenuDefaultStyle = {
    styleType: "menu",
    guiText: "Menu",
    name: "Default-Menu",
    isDefault: true,
    backgroundColor: {r: 0, g: 0, b: 0, a: 0.8},
    titleScreenBackgroundColor: {r: 44, g: 62, b: 80, a: 1.0},
    buttonBackgroundColor: {r: 50, g: 128, b: 177, a: 1.0},
    buttonHoverColor: {r: 70, g: 148, b: 197, a: 1},
    textColor: {r: 255, g: 255, b: 255, a: 1},
    titleColor: {r: 255, g: 255, b: 255, a: 1},
    buttonTextColor: {r: 255, g: 255, b: 255, a: 1},
    outlineColor: {r: 255, g: 255, b: 255, a: 1},
    iconColor: {r: 255, g: 255, b: 255, a: 1},
    alias: "Styles/Default-Menu",
    type: "Style",
    opacity: 0.9
};

module.exports = {
    MenuDefaultStyle
};
